import withScroll from '../hoc/withScroll'

export default withScroll({
  name: 'form-occasion-card',

  componentDidMount () {},

  onScroll ({ y }) {
    if (y > 100) {
      this.el.classList.add('is-scrolled')
    } else {
      this.el.classList.remove('is-scrolled')
    }
  },
})
